<dialog #errorDialog>
  <div
    *ngIf="irwinPushError"
    style="display: flex; align-items: center; flex-direction: column"
  >
    <div><mat-error>An Error occurred while pushing IRWIN data</mat-error></div>
    <textarea
      readonly
      [value]="irwinPushError"
      style="border: none; min-width: 700px; min-height: 376px"
    ></textarea>
  </div>
  <button class="primary-button" (click)="errorDialog.close()">Close</button>
</dialog>
<wfdss-irwin-tool-presentation
  #presentation
  [irwinData]="irwinDataToDisplay"
  (fullIrwinJsonRequested)="handleFullIrwinJsonFetch($event)"
  (partialIrwinJsonRequested)="fetchIrwinData($event)"
  (irwinIdChangeEvent)="handleNewIrwinIdSearch($event)"
  (attributePushEvent)="handleAttributePushRequest($event)"
  (attributesPushEvent)="handleAttributesPushRequest($event)"
>
  <!-- TODO; Add attribute "SYNC" event, which is more robust than simply pushing to IRWIN -->
</wfdss-irwin-tool-presentation>
